import moment from '@/utils/moment-wrapper';
import * as highcharts from 'highcharts';
import sanitizeHTML from 'sanitize-html';
import { getKey as getSessionDataKey } from '@/data/session/session-globals';
import { i18n_locale } from '@/utils/i18n';

export const $pendo = { moment, highcharts, sanitize: sanitizeHTML };

function defineSessionGlobal (Vue, key, propertyName) {
    Object.defineProperty(Vue.config.globalProperties, propertyName, {
        enumerable: true,
        configurable: true,
        get () {
            return getSessionDataKey(key);
        },
    });
}

const pendoGlobalsPlugin = {
    install: (Vue) => {
        defineSessionGlobal(Vue, 'activeUser', '$activeUser');
        defineSessionGlobal(Vue, 'activeSubscription', '$activeSubscription');
        defineSessionGlobal(Vue, 'activeOrganization', '$activeOrganization');
        defineSessionGlobal(Vue, 'activeApplications', '$activeApplicationMap');

        Vue.config.globalProperties.$normalizedLocale = () => i18n_locale.value;

        Vue.config.globalProperties.$pendo = $pendo;
    },
};

export default pendoGlobalsPlugin;
